/**
 * 登入提示組件
 * 顯示登入提示和按鈕，處理手動登入
 */

import * as React from "react";
import { Button, makeStyles, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  loginContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
    gap: "16px",
    flex: 1,
    minHeight: 0,
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: "8px",
    border: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  loginMessage: {
    textAlign: "center",
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase400,
  },
  errorMessage: {
    color: tokens.colorPaletteRedForeground2,
    fontSize: tokens.fontSizeBase300,
    textAlign: "center",
  },
});

const LoginPrompt = ({ onLogin, isLoggingIn, loginError }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginMessage}>
        {t('sso_failed_message')}
      </div>
      {loginError && (
        <div className={styles.errorMessage}>
          {loginError}
        </div>
      )}
      <Button
        appearance="primary"
        onClick={onLogin}
        disabled={isLoggingIn}
      >
        {isLoggingIn ? t('logging_in') : t('login_button')}
      </Button>
    </div>
  );
};

export default LoginPrompt;

